import { render, staticRenderFns } from "./AEditarPlanConceptos.vue?vue&type=template&id=58f3f4e0"
import script from "./AEditarPlanConceptos.vue?vue&type=script&lang=js"
export * from "./AEditarPlanConceptos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports